import { ListItem, Typography } from "@mui/material";

interface IAnnouncementProps {
  blok: { text: string };
}

const Announcement = ({ blok }: IAnnouncementProps) => {
  return (
    <ListItem
      sx={{
        padding: "24px 16px 24px 16px",
        boxShadow:
          "rgba(255, 255, 255, 0.5) 2px 2px 2px 0px inset, rgba(0, 0, 0, 0.1) 7px 7px 20px 0px, rgba(0, 0, 0, 0.1) 4px 4px 5px 0px",
        borderRadius: "8px",
        background: "#fff",
      }}
    >
      <Typography
        sx={{
          fontFamily: "var(--cygreMedium), sans-serif",
          color: "#2E263D",
          fontSize: "16px",
          lineHeight: "24px",
        }}
      >
        {blok.text}
      </Typography>
    </ListItem>
  );
};

export default Announcement;
